import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import axios from 'axios';
import { BrdsqlService } from '../../core/services/brdsql.service';
import { Authenticationservice } from '../../core/services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  userdata: any = Object;
  yearSelect: any = [];
  yearSelected: string = "";
  sYear = new UntypedFormControl(null, Validators.required);  // เลือกปีการผลิตสำหรับเก็บไว้ใช้ทั้ง app
  showNewMenu = false;

  constructor(private router: Router,
    private auth: Authenticationservice,
    private brdservice: BrdsqlService,
    //private auth2: AuthService,
    //private route: ActivatedRoute
  ) {
    this.userdata = this.auth.Authention();
    let check = this.auth.Alertreload();
    this.zone = this.userdata.zonedata;
    console.log('this.userdata:', this.userdata);
    if (!this.userdata.supcode) {
      this.router.navigateByUrl('/loign');
    }
    this.yearSelect = this.brdservice.yearID;
    if (localStorage.getItem('yearCr')) {
      this.yearSelected = localStorage.getItem('yearCr')
    }
    if (localStorage.getItem("supcode") === '901') {
      this.showNewMenu = true
    }
    /*this.photourl = this.userdata.suppic_url;
    this.takesupcode = this.userdata.supcode;*/
  }


  zone: string;
  ngOnInit(): void {
    // let route = this.router.routerState.snapshot.url || null;
    // console.log('this.route:', route);
    // localStorage.setItem('route', route);
    //this.Loadtopbar();
    //this.Lonitiflydata();
  }

  setYear(f: any) {
    localStorage.setItem('yearCr', f.sYear);
    // localStorage.setItem('yearLb',f.sYear);
  }

  Logout() {
    //this.auth2.logout();
    localStorage.removeItem('userdata');
    localStorage.clear();
    this.router.navigateByUrl("/login");
  }

  topbardata: any;
  zonedata: any;
  Loadtopbar() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_Assess")
      .then(res => {
        let data = res.data.recordsets[0];

        this.topbardata = data.filter(el => el.supzone === "BRD");;
        this.zonedata = data.filter(el => el.supzone == this.zone);
      })
      .catch(error => { throw (error) });
  }

  datanoti: any;
  Lonitiflydata() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_ERcnt_ny?supcode=" + this.userdata.supcode)
      .then(res => {
        this.datanoti = res.data.recordset;
      })
      .catch(error => { throw (error) });
  }

}
